<div c-toggle="workflowsVisible" c-toggle-options="{type: 'fade'}" >
    <search-view query="query" highlight="highlight" search-url="searchUrl" filter-config="filterConfig"></search-view>
</div>